import type { AccountRole } from "@workspace/api-client-react";

const TEAM_NAV_ROLES: ReadonlySet<AccountRole> = new Set([
  "ORG_OWNER",
  "ORG_ADMIN",
  "ORG_MEMBER",
]);

export function canAccessTeam(role?: AccountRole | null): boolean {
  return !!role && TEAM_NAV_ROLES.has(role);
}
